<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      d="M18.993 2.59319C19.2495 1.82358 19.0069 1.07285 18.5076 0.583496L6.91699 12.1741C7.06495 12.3194 7.19277 12.4852 7.2962 12.6671L10.3913 18.1102C11.2255 19.5772 13.4028 19.3639 13.9364 17.763L18.993 2.59319Z"
      :fill="color"
    />
    <path
      d="M16.503 0.103678C17.2726 -0.152862 18.0233 0.0897655 18.5127 0.58909L6.9221 12.1797C6.77677 12.0317 6.61103 11.9039 6.42912 11.8005L0.985943 8.70533C-0.480995 7.87119 -0.267729 5.69392 1.33319 5.16029L16.503 0.103678Z"
      :fill="color"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "20",
  },
  height: {
    type: [String, Number],
    default: "20",
  },
  color: {
    type: String,
    default: "#003D6A",
  },
});
</script>
